import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MissionService } from '../../../services/mission.service';
import { DataColumn } from '../../../models';
import { SharedModule } from '../../../shared/shared.module';
import { UserComponent } from '../../../shared/user/user.component';
import { ReferenceTitleComponent } from '../agency-etab-missions-details/reference-title/reference-title.component';
import { AssignActionComponent } from './assign-action/assign-action.component';
import moment from 'moment';

@Component({
    selector: 'app-agency-direct-assign',
    templateUrl: './agency-direct-assign.component.html',
    styleUrl: './agency-direct-assign.component.scss',
    standalone: false,
})
export class AgencyDirectAssignComponent implements OnInit {
    component: any[] = [UserComponent];
    isLoading: boolean = false;
    customColumns: DataColumn[] = [
        {
            header: 'Référence',
            fieldName: 'missionTitle',
            component: ReferenceTitleComponent,
            dataType: 'component',
            col: 'col',
        },
        {
            header: 'Établissement',
            fieldName: 'etablissementNom',
            dataType: 'string',
            col: 'col',
        },
        {
            header: 'Service d’affectation',
            fieldName: 'serviceAffectationsName',
            dataType: 'string',
            col: 'col',
        },
        {
            header: 'Poste',
            fieldName: 'typePoste',
            dataType: 'string',
            col: 'col',
        },
        {
            header: 'Dates',
            fieldName: 'duration',
            fieldNameStartDate: 'startdate',
            fieldNameEndDate: 'enddate',
            dataType: 'date',
            col: 'col',
        },
        {
            header: 'Type',
            fieldName: 'missionType',
            dataType: 'string',
            col: 'col',
        },
        {
            header: 'Actions',
            fieldName: '',
            component: AssignActionComponent,
            dataType: 'component',
            col: 'col',
            unClickable: true,
        },
    ];

    missionListFiltered: any[] = [];
    offset = 0;
    size = 10;
    totalItems = 0;
    selectedSite: null | number = null;
    siteList: any[] = [];
    inputSearch: string = '';

    constructor(
        private dialog: MatDialog,
        private api: MissionService
    ) { }

    ngOnInit(): void {
        this.loadMissions();
    }

    private loadMissions(): void {
        this.isLoading = true;
        this.api
            .getUnassignedMissions(this.offset, this.size, this.inputSearch, this.selectedSite || 0)
            .subscribe({
                next: (res: any) => {
                    this.missionListFiltered = (res.missions || []).map((mission: any) => {
                        if (mission.typecontat == 'LIBERAL') {
                            mission.typecontat = 'Intérim';
                        }
                        mission.regionCode = mission?.regionCode ?? '';
                        mission.isUrgent = mission?.isurgent;
                        mission.missionType = mission.isfragmentable ? 'Divisible' : 'Pas divisible';
                        return mission;
                    });
                    this.totalItems = res.totalItems || 0;

                    if (res.siteList && res.siteList.length > 0) {
                        this.siteList = res.siteList;
                    }
                },
                error: () => {
                    this.missionListFiltered = [];
                    this.totalItems = 0;
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
    }

    pagination(event: any) {
        this.size = event.pageSize;
        this.offset = event.pageIndex * this.size;
        this.loadMissions();
    }

    searchItem(event: any) {
        if (!!event) {
            this.inputSearch = event.target.value.trim().toLowerCase();
            this.offset = 0;
            this.loadMissions();
        }
    }

    toggleSelectSite(event: any, item: any) {
        if (event) {
            this.selectedSite = item.id;
        } else {
            this.selectedSite = null;
        }
        this.offset = 0;
        this.loadMissions();
    }

    onMissionAssigned() {
        this.loadMissions();
    }
}
